module.exports = __webpack_public_path__ + "static/images/smart-spot.426f25e6cbf91cd8d8ea5e85df2fc423.svg";